import React from 'react';
import MonitoringSelector from './MonitoringSelector';
const MonitoringButtonToolbar = ({ projectId, versionId, projectLastVersion }) => {
  return (
    <div className='d-flex justify-content-start align-items-center gap-1 mb-4 monitoringLinkBanner'>
      <MonitoringSelector
        projectId={projectId}
        versionId={versionId ? parseInt(versionId) : null}
        projectLastVersion={projectLastVersion}
      />
      oppure
      <div className='d-flex justify-content-center align-items-center'>
        {/* <Button variant='link' onClick={() => history.push(`/valutazione/${projectId}`)}>
          Torna al progetto
        </Button> */}
        <a href={`/valutazione/${projectId}`}>Torna al progetto</a>
      </div>
    </div>
  );
};

export default MonitoringButtonToolbar;
